<script setup lang="ts">
import Icon from "./Icon.vue";

const { item, level } = defineProps({ item: Object, level: Number });
</script>

<template>
	<!---Single Item-->
	<v-list-item
		:to="item.route"
		rounded
		class="mb-1"
		:disabled="item.disabled"
		color="primary"
	>
		<template v-slot:prepend>
			<div class="d-flex flex-column align-center" style="width: 20px">
				<Icon :item="item.icon" :level="level" />
			</div>
		</template>
		<v-list-item-title style="font-size: 15px; font-weight: 500" class="ml-9">{{
			$t(item.translation_key)
		}}</v-list-item-title>
	</v-list-item>
</template>
